import styled from "styled-components";

import { theme } from '../../configuration';

const AppContainer = styled.div`
  margin: 0px;
  max-width: 1200px;
  bottom: 0px;
  
  font-family: ${theme.fonts.main};
  font-size: ${theme.sizes.main};
  text-align: left;
  padding: 0px 10px 0px 10px;
  
  background-color: #ffffff;
`;

export default AppContainer;
